// frontend/src/components/entry/EntryDialog.jsx
//
// The popup every entry screen is (`entryScreen.js`): the claim question,
// the setup step, the import, the paywall and their retry cards. One shape,
// the app's popup shape (`styles/dialog-form.css`), so the way into the app
// looks like the app. It never closes on its own: the screen it holds is the
// only way forward, so there is no close button, and Escape and a click on
// the backdrop do nothing.
//
// `actions` is the button bar; a screen with nothing to press yet (a read
// still loading, an import under way) passes none and has no bar.

import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

const SIZE_CLASS = {
  // One question, or a status, over its buttons.
  confirm: 'dialog-form--confirm',
  // A form.
  standard: '',
};

/**
 * @param {import('react').ReactNode} title    the title bar
 * @param {'confirm'|'standard'} [size]
 * @param {import('react').ReactNode} [actions]  the button bar's buttons
 * @param {string} [className]  this screen's own class on the popup
 */
export default function EntryDialog({
  title, size = 'confirm', actions = null, className = '', children,
}) {
  if (!(size in SIZE_CLASS)) throw new Error(`EntryDialog: unknown size "${size}"`);
  return (
    <Dialog open className={`dialog-form ${SIZE_CLASS[size]} ${className}`}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>{children}</DialogContent>
      {actions && <DialogActions>{actions}</DialogActions>}
    </Dialog>
  );
}
